import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import DonutChart2 from "../Charts/Doughnut";
import {
  GroupedBarChart,
  IGroupedData,
  ILineData,
} from "../Charts/GroupedBarChart";
import { debug } from "console";

type Props = {
  retailerScoreCardData: any;
};
function RetailerScorecardDetailsCharts(props: Props) {
  const [TotalDougnutData, setTotalDougnutData] = useState<any[]>([
    { name: "Red", value: 0, color: "#F42336" },
    { name: "yellow", value: 0, color: "#F7D842" },
    { name: "green", value: 0, color: "#98CB4A" },
    { name: "white", value: 0, color: "#fff" },
  ]);

  const [networkDonutData, setNetworkDonutData] = useState<any[]>([
    { name: "Red", value: 0, color: "#F42336" },
    { name: "yellow", value: 0, color: "#F7D842" },
    { name: "green", value: 0, color: "#98CB4A" },
    { name: "white", value: 0, color: "#fff" },
  ]);

  const [salesDonutData, setSalesDonutData] = useState<any[]>([
    { name: "Red", value: 0, color: "#F42336" },
    { name: "yellow", value: 0, color: "#F7D842" },
    { name: "green", value: 0, color: "#98CB4A" },
    { name: "white", value: 0, color: "#fff" },
  ]);

  const [aftersalesDonutData, setAftersalesDonutData] = useState<any[]>([
    { name: "Red", value: 0, color: "#F42336" },
    { name: "yellow", value: 0, color: "#F7D842" },
    { name: "green", value: 0, color: "#98CB4A" },
    { name: "white", value: 0, color: "#fff" },
  ]);

  const [drawChart, setDrawChart] = useState(false);

  const [networkChartData, setNetworkChartData] = useState({
    Red: 0,
    Green: 0,
    Yellow: 0,
    Total: 0,
  });
  const [salesChartData, setSalesChartData] = useState({
    Red: 0,
    Green: 0,
    Yellow: 0,
    Total: 0,
  });
  const [aftersalesChartData, setAftersalesChartData] = useState({
    Red: 0,
    Green: 0,
    Yellow: 0,
    Total: 0,
  });
  const [totalsalesChartData, setTotalsalesChartData] = useState({
    Red: 0,
    Green: 0,
    Yellow: 0,
    Total: 0,
  });
  const [totalSectionScore, setTotalSectionScore] = useState(0);
  const [valueToPrintGraph1, setvalueToPrintGraph1] = useState("");
  const [valueToPrintGraph2, setvalueToPrintGraph2] = useState("");
  const [valueToPrintGraph3, setvalueToPrintGraph3] = useState("");
  const [valueToPrintGraph4, setvalueToPrintGraph4] = useState("");

  useEffect(() => {
    networkChartData.Green = 0;
    networkChartData.Red = 0;
    networkChartData.Yellow = 0;
    networkChartData.Total = 0;

    salesChartData.Green = 0;
    salesChartData.Red = 0;
    salesChartData.Yellow = 0;
    salesChartData.Total = 0;

    aftersalesChartData.Green = 0;
    aftersalesChartData.Red = 0;
    aftersalesChartData.Yellow = 0;
    aftersalesChartData.Total = 0;
    if (props.retailerScoreCardData && props.retailerScoreCardData.length > 0) {
      for (let i = 0; i < props.retailerScoreCardData[0].length; i++) {
        if (props.retailerScoreCardData[0][i].ScoreType === "R") {
          networkChartData.Red += props.retailerScoreCardData[0][i].FinalPoints;
        } else if (props.retailerScoreCardData[0][i].ScoreType === "G") {
          networkChartData.Green +=
            props.retailerScoreCardData[0][i].FinalPoints;
        } else if (props.retailerScoreCardData[0][i].ScoreType === "Y") {
          networkChartData.Yellow +=
            props.retailerScoreCardData[0][i].FinalPoints;
        }
      }

      for (let i = 0; i < props.retailerScoreCardData[1].length; i++) {
        if (props.retailerScoreCardData[1][i].ScoreType === "R") {
          salesChartData.Red += props.retailerScoreCardData[1][i].FinalPoints;
        } else if (props.retailerScoreCardData[1][i].ScoreType === "G") {
          salesChartData.Green += props.retailerScoreCardData[1][i].FinalPoints;
        } else if (props.retailerScoreCardData[1][i].ScoreType === "Y") {
          salesChartData.Yellow +=
            props.retailerScoreCardData[1][i].FinalPoints;
        }
      }

      for (let i = 0; i < props.retailerScoreCardData[2].length; i++) {
        if (props.retailerScoreCardData[2][i].ScoreType === "R") {
          aftersalesChartData.Red +=
            props.retailerScoreCardData[2][i].FinalPoints;
        } else if (props.retailerScoreCardData[2][i].ScoreType === "G") {
          aftersalesChartData.Green +=
            props.retailerScoreCardData[2][i].FinalPoints;
        } else if (props.retailerScoreCardData[2][i].ScoreType === "Y") {
          aftersalesChartData.Yellow +=
            props.retailerScoreCardData[2][i].FinalPoints;
        }
      }

      networkChartData.Total =
        networkChartData.Red + networkChartData.Green + networkChartData.Yellow;
      salesChartData.Total =
        salesChartData.Red + salesChartData.Green + salesChartData.Yellow;
      aftersalesChartData.Total =
        aftersalesChartData.Red +
        aftersalesChartData.Green +
        aftersalesChartData.Yellow;

      setNetworkDonutData([
        { name: "Red", value: networkChartData.Red, color: "#F42336" },
        { name: "yellow", value: networkChartData.Yellow, color: "#F7D842" },
        { name: "green", value: networkChartData.Green, color: "#98CB4A" },
        { name: "white", value: AppContext.NetworkTotalScore - networkChartData.Total, color: "#fff" },
      ]);
      setSalesDonutData([
        { name: "Red", value: salesChartData.Red, color: "#F42336" },
        { name: "yellow", value: salesChartData.Yellow, color: "#F7D842" },
        { name: "green", value: salesChartData.Green, color: "#98CB4A" },
        { name: "white", value: AppContext.SalesTotalScore - salesChartData.Total, color: "#fff" },
      ]);
      setAftersalesDonutData([
        { name: "Red", value: aftersalesChartData.Red, color: "#F42336" },
        { name: "yellow", value: aftersalesChartData.Yellow, color: "#F7D842" },
        { name: "green", value: aftersalesChartData.Green, color: "#98CB4A" },
        {
          name: "white",
          value: AppContext.AftersalesTotalScore - aftersalesChartData.Total,
          color: "#fff",
        },
      ]);
      setvalueToPrintGraph1( networkChartData.Total +"/"+AppContext.NetworkTotalScore );
      setvalueToPrintGraph2(salesChartData.Total+ "/" + AppContext.SalesTotalScore);
      setvalueToPrintGraph3(aftersalesChartData.Total+ "/" + AppContext.AftersalesTotalScore);
      setTotalDougnutData([
        {
          name: "Red",
          value:
            aftersalesChartData.Red + salesChartData.Red + networkChartData.Red,
          color: "#F42336",
        },
        {
          name: "yellow",
          value:
            aftersalesChartData.Yellow +
            salesChartData.Yellow +
            networkChartData.Yellow,
          color: "#F7D842",
        },
        {
          name: "green",
          value:
            aftersalesChartData.Green +
            salesChartData.Green +
            networkChartData.Green,
          color: "#98CB4A",
        },
        {
          name: "white",
          value:
            400 -
            aftersalesChartData.Total +
            salesChartData.Total +
            networkChartData.Total,
          color: "#fff",
        },
      ]);
      setTotalSectionScore(
        networkChartData.Total +
          salesChartData.Total +
          aftersalesChartData.Total
      );
      setvalueToPrintGraph4(networkChartData.Total +
        salesChartData.Total +
        aftersalesChartData.Total+ "/" + (AppContext.NetworkTotalScore+ AppContext.SalesTotalScore + AppContext.AftersalesTotalScore));
  
      MakeBarCharData();
      setDrawChart(true);
    }
  }, [props.retailerScoreCardData]);

  const [GROUPED_BAR_CHART_DATA, setGROUPED_BAR_CHART_DATA] = useState<
    IGroupedData[]
  >([]);

  const [lineDataNumbers, setlineDataNumbers] = useState<[number, number][]>(
    []
  );
  const [GROUPED_BAR_CHART_DATA2, setGROUPED_BAR_CHART_DATA2] = useState<
    IGroupedData[]
  >([]);
  const aMonthNames = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  function MakeBarCharData() {
    if (GROUPED_BAR_CHART_DATA.length > 0) {
      var j = GROUPED_BAR_CHART_DATA.length;
      for (var i = 0; i < j; i++) {
        GROUPED_BAR_CHART_DATA.pop();
      }
    }
    var l_intMonth1Total = 0;
    var l_intMonth2Total = 0;
    var l_intMonth3Total = 0;
    var l_intMonth4Total = 0;
    var l_intMonth5Total = 0;
    var l_intMonth6Total = 0;
    var l_intMonth7Total = 0;
    var l_intMonth8Total = 0;
    var l_intMonth9Total = 0;
    var l_intMonth10Total = 0;
    var l_intMonth11Total = 0;
    var l_intMonth12Total = 0;

    var ListData = props.retailerScoreCardData[3];
    for (var k = 0; k < aMonthNames.length; k++) {
      GROUPED_BAR_CHART_DATA.push({
        label: aMonthNames[k],
        values: [],
      });
    }

    if (ListData != null) {
      for (var k = 0; k < ListData.length; k++) {
        if (ListData[k].NumericMonth == 1) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;
            if (employee.label == "Jan") {
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth1Total += parseFloat(ListData[k].FinalPoints);
              found = true;
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Jan",
              values: [ListData[k].FinalPoints],
            });
            l_intMonth1Total = parseFloat(ListData[k].FinalPoints);
          }
        }
        if (ListData[k].NumericMonth == 2) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;
            if (employee.label == "Feb") {
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth2Total += parseFloat(ListData[k].FinalPoints);
              found = true;
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Feb",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth2Total = parseFloat(ListData[k].FinalPoints);
          }
        }
        if (ListData[k].NumericMonth == 3) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;
            if (employee.label == "Mar") {
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth3Total += parseFloat(ListData[k].FinalPoints);
              found = true;
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Mar",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth3Total = parseFloat(ListData[k].FinalPoints);
          }
        }
        if (ListData[k].NumericMonth == 4) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;
            if (employee.label == "Apr") {
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth4Total += parseFloat(ListData[k].FinalPoints);
              found = true;
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Apr",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth4Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 5) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;
            if (employee.label == "May") {
              found = true;

              employee.values.push(ListData[k].FinalPoints);
              l_intMonth5Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "May",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth5Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 6) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Jun") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth6Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Jun",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth6Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 7) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Jul") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth7Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Jul",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth7Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 8) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Aug") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth8Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Aug",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth8Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 9) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Sep") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth9Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Sep",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth9Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 10) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Oct") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth10Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Oct",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth10Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 11) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Nov") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth11Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Nov",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth11Total = parseFloat(ListData[k].FinalPoints);
          }
        } else if (ListData[k].NumericMonth == 12) {
          var found = false;
          GROUPED_BAR_CHART_DATA.map((employee, index) => {
            var item = useState<IGroupedData>;

            if (employee.label == "Dec") {
              found = true;
              employee.values.push(ListData[k].FinalPoints);
              l_intMonth12Total += parseFloat(ListData[k].FinalPoints);
            }
          });
          if (found == false) {
            GROUPED_BAR_CHART_DATA.push({
              label: "Dec",
              values: [ListData[k].FinalPoints],
            });

            l_intMonth12Total = parseFloat(ListData[k].FinalPoints);
          }
        }
      }
    }
    GROUPED_BAR_CHART_DATA.map((employee, index) => {
      if (employee.values.length == 0) {
        employee.values = [0, 0, 0];
      }
    });

    if (lineDataNumbers.length > 0) {
      var j = lineDataNumbers.length;
      for (var i = 0; i < j; i++) lineDataNumbers.pop();
    }
    lineDataNumbers.push([1, l_intMonth4Total]);
    lineDataNumbers.push([2, l_intMonth5Total]);
    lineDataNumbers.push([3, l_intMonth6Total]);
    lineDataNumbers.push([4, l_intMonth7Total]);
    lineDataNumbers.push([5, l_intMonth8Total]);
    lineDataNumbers.push([6, l_intMonth9Total]);
    lineDataNumbers.push([7, l_intMonth10Total]);
    lineDataNumbers.push([8, l_intMonth11Total]);
    lineDataNumbers.push([9, l_intMonth12Total]);
    lineDataNumbers.push([10, l_intMonth1Total]);
    lineDataNumbers.push([11, l_intMonth2Total]);
    lineDataNumbers.push([12, l_intMonth3Total]);
  }
  return (
    <div>
      {drawChart && (
        <>
          {" "}
          <div>
            <div className="flex-details">
              <div className="charts-flex donut-flex">
                <DonutChart2 data={TotalDougnutData}  totalValueToPrint={valueToPrintGraph4}/>
              </div>
              <GroupedBarChart
                data={GROUPED_BAR_CHART_DATA}
                lineData={lineDataNumbers}
              />
            </div>
            <div className="flex-details donut-flex">
              <div className="charts-flex">
                <DonutChart2 data={networkDonutData}  totalValueToPrint={valueToPrintGraph1}/>
              </div>
              <div className="charts-flex">
                <DonutChart2 data={salesDonutData} totalValueToPrint={valueToPrintGraph2}/>
              </div>
              <div className="charts-flex">
                <DonutChart2 data={aftersalesDonutData}  totalValueToPrint={valueToPrintGraph3} />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default RetailerScorecardDetailsCharts;
